import {
  CreateGUFAddRealisedInstallationTask,
  EditGUFAddRealisedInstallationTask,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

/**
 * Schema for RealisedLoop within a RealisedInstallation
 */
export const realisedLoopSchema = addSchema<
  (
    | CreateGUFAddRealisedInstallationTask
    | EditGUFAddRealisedInstallationTask
  )["sourcedocumentData"]["realisedLoops"]
>({
  type: "array",
  title: "Gerealiseerde bodemlusen",
  minItems: 0,
  items: {
    type: "object",
    title: "Gerealiseerde bodemlus",
    required: ["realisedLoopId", "endDepthBottom"],
    properties: {
      ...pickGufPrimitiveLibraryFields([
        "realisedLoopId",
        "endDepthBottom",
        "loopType",
        "realisedGeometryType",
        "realisedLoopPos",
        "segments",
      ]),
      // geometryType maps to realisedGeometryType in the schema ("Point"|"Curve")
      geometryType: pickGufPrimitiveLibraryFields(["realisedGeometryType"]).realisedGeometryType,
    },
  },
});
